import React, {useContext} from 'react';
import Indicator from './Indicator';
import { createPortal } from 'react-dom';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import usePortalDom from '../hooks/usePortalDom';
import {PageContext} from '../ComponentNavigatorV2/PageContext';

interface AllForIndicator {
  rootStore?: RootStore;
  visible?: boolean;
}
const AllForIndicator = function(props: AllForIndicator) {
  const { galleryStore } = props.rootStore!;
  
  // const { jigsaw } = galleryStore;
  // 如果当前是拼图底部已经显示的情况下，任何挂件都不需要显示
  // const { bottomShow } = jigsaw;
  const { total, mode, list} = galleryStore;
  const context = useContext(PageContext);
  const wrapper = usePortalDom({
    parentElement:window.document.getElementById(`page-top-${context.cid}`)! as HTMLDivElement
  });

  if (props.visible === false) return null;

  return wrapper ? createPortal(
    <Indicator
      total={total}
      mode={mode}
      loadedTotal={list.length}
      // top={galleryStore.morePhoto ? 70 : 36}
    />,
    wrapper
  ) : null;
};

export default inject('rootStore')(observer(AllForIndicator));
